export const mockEolLinehaulJunctions = [
  { id: 1, code: "ATL", name: "ATL", status: "Active", linehaulJunction: true },
  { id: 2, code: "BOS", name: "BOS", status: "Active", linehaulJunction: true },
  { id: 3, code: "CHI", name: "CHI", status: "Active", linehaulJunction: true },
  { id: 4, code: "DAL", name: "DAL", status: "Active", linehaulJunction: true },
  { id: 5, code: "DEN", name: "DEN", status: "Active", linehaulJunction: true },
  { id: 6, code: "HOU", name: "HOU", status: "Active", linehaulJunction: true },
  { id: 7, code: "LAX", name: "LAX", status: "Active", linehaulJunction: true },
  { id: 8, code: "MIA", name: "MIA", status: "Active", linehaulJunction: true },
  { id: 9, code: "NYC", name: "NYC", status: "Active", linehaulJunction: true },
  {
    id: 10,
    code: "PHX",
    name: "PHX",
    status: "Active",
    linehaulJunction: true,
  },
  {
    id: 11,
    code: "SEA",
    name: "SEA",
    status: "Active",
    linehaulJunction: true,
  },
  {
    id: 12,
    code: "SFO",
    name: "SFO",
    status: "Active",
    linehaulJunction: true,
  },
] as const;
